import { jsx } from 'react/jsx-runtime';
import { formatDataForTooltip } from '../utilities/formatDataForTooltip.js';
import { TooltipContent } from '../components/TooltipContent/TooltipContent.js';

function useRenderTooltipContent({
  tooltipOptions = {},
  theme,
  data
}) {
  return function renderTooltipContent(tooltipData) {
    if ((tooltipOptions === null || tooltipOptions === void 0 ? void 0 : tooltipOptions.renderTooltipContent) != null) {
      const {
        renderTooltipContent,
        ...formatters
      } = tooltipOptions;
      return renderTooltipContent({ ...tooltipData,
        dataSeries: data,
        formatters,
        theme
      });
    }

    const {
      title,
      formattedData
    } = formatDataForTooltip({
      data: tooltipData,
      tooltipOptions
    });

    if (formattedData[0].data.length === 0) {
      return null;
    } else {
      return /*#__PURE__*/jsx(TooltipContent, {
        data: formattedData,
        theme: theme,
        title: title
      });
    }
  };
}

export { useRenderTooltipContent };
